import { FC, PropsWithChildren } from "react";
import { Box } from "@mui/material";

interface BlockProps {
  showTopBar?: boolean;
  noBorder?: boolean;
}

export const Block: FC<PropsWithChildren<BlockProps>> = ({
  children,
  showTopBar,
  noBorder = false,
}) => {
  return (
    <Box
      sx={{
        border: noBorder ? "" : "1px solid #dadce0",
        borderRadius: "8px",
        backgroundColor: "white",
        overflow: "hidden",
        marginBottom: "1rem",
      }}
    >
      {showTopBar && (
        <Box
          sx={{
            height: 10,
            backgroundColor: "#a2d2aa",
          }}
        />
      )}
      <Box
        sx={{
          padding: 2,
        }}
      >
        {children}
      </Box>
    </Box>
  );
};
